import log from 'salvo-lite/log'
import EventEmitter from 'eventemitter3'

class HTML5Video {
    constructor (elem) {
        this._video = elem
        this._em = new EventEmitter()
        this.onInit()
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        log.debug(this.constructor.name, 'Initiating')
        this.doEvents()
        log.debug(this.constructor.name, 'Initiated')
    }

    listen (event, callback) {
        return this._em.on(event, callback)
    }

    doEvents () {
        this._video.addEventListener('play', e => {
            this._em.emit('play', e)
        })
        this._video.addEventListener('pause', e => {
            this._em.emit('pause', e)
        })
        this._video.addEventListener('timeupdate', e => {
            this._em.emit('update', e)
        })
        this._video.addEventListener('loadedmetadata', e => {
            this._em.emit('loadedmetadata', e)
        })
        this._video.addEventListener('ended', e => {
            this._em.emit('ended', e)
        })
    }

    pause () {
        this._video.pause()
    }

    play () {
        this._video.play()
    }

    load () {
        this._video.load()
    }

    isPaused () {
        return this._video.paused
    }

    hasEnded () {
        return this._video.ended
    }

    mute () {
        this._video.muted = true
    }

    unmute () {
        this._video.muted = false
    }

    toggleMute () {
        this._video.muted = !this._video.muted
    }

    isMuted () {
        return this._video.muted
    }

    getDuration () {
        return this._video.duration
    }

    getCurrentTime () {
        return this._video.currentTime
    }

    setCurrentTime (time = 0) {
        this._video.currentTime = time
    }

    getElem () {
        return this._video
    }
}

export default HTML5Video



// WEBPACK FOOTER //
// ./src/resources/scripts/helpers/HTML5Video.js